import loginTypes from './loginTypes'
import { actionCreator } from '../actionCreator'

export default {
  ...actionCreator({
    login: loginTypes.LOGIN,
    loginSuccess: loginTypes.LOGIN_SUCCESS,
    loginFailure: loginTypes.LOGIN_FAILURE,
    logout: loginTypes.LOGOUT,
    clearLogin: loginTypes.CLEAR_LOGIN,
    didTryAutoLogin: loginTypes.DID_TRY_AUTOLOGIN
  })
}
